import { TextField } from '@mui/material'
import { useEffect, useState } from 'react'

const DEBOUNCE_DELAY_MS = 300

interface EmailFilterProps {
    email: string
    onChange: (email: string) => void
}

export function EmailFilter({ email, onChange }: EmailFilterProps) {
    const [localValue, setLocalValue] = useState(email)

    useEffect(() => {
        if (localValue === email) {
            return
        }
        const timeoutId = setTimeout(() => {
            onChange(localValue)
        }, DEBOUNCE_DELAY_MS)
        return () => clearTimeout(timeoutId)
    }, [localValue, onChange, email])

    useEffect(() => {
        setLocalValue(email)
    }, [email])

    const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setLocalValue(event.target.value)
    }

    return (
        <TextField
            label="Email"
            placeholder="Search by email..."
            value={localValue}
            onChange={handleEmailChange}
            fullWidth
        />
    )
}
